import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";
import theme from "../../../../Themes/defaultTheme";
import { getSelectableFirms } from "../../../../../Utils/apis/professionalContactsApi";

const M_FirmPicker = ({
  id,
  label,
  loanId,
  role,
  value,
  onChange,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!loanId || !role) return undefined;
    setLoading(true);
    setLoadError(null);
    getSelectableFirms(loanId, role)
      .then((firms) => {
        if (!cancelled) setOptions(Array.isArray(firms) ? firms : []);
      })
      .catch((err) => {
        if (!cancelled) setLoadError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [loanId, role]);

  const selected = options.find((firm) => firm.id === value) || null;

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        id={id}
        disabled={disabled}
        options={options}
        value={selected}
        getOptionLabel={(option) => option?.name || ""}
        getOptionSelected={(option, val) => option.id === val?.id}
        onChange={(_event, newValue) => onChange(newValue)}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Please type to search…"
            variant="outlined"
            size="small"
            margin="dense"
            fullWidth={fullWidth}
            required={required}
            error={Boolean(error) || Boolean(loadError)}
            helperText={
              loadError ? "Couldn't load firms for this role" : helperText
            }
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={16} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </ThemeProvider>
  );
};

M_FirmPicker.defaultProps = {
  fullWidth: true,
  required: false,
  disabled: false,
  error: false,
  helperText: "",
};

M_FirmPicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  loanId: PropTypes.string,
  role: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default M_FirmPicker;
